module.exports = __webpack_public_path__ + "img/dog-couch-camera.ebcabfca.jpg";